import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import config from "./config";

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      key: `${config.namespace}__state`
    })
  ],
  state: {
    account: null,
    membership: null
  },
  mutations: {
    SET_ACCOUNT(state, account) {
      state.account = account;
    },
    SET_MEMBERSHIP(state, membership) {
      state.membership = membership;
    }
  }
});

export default store;
